module.exports = __webpack_public_path__ + "static/media/fire.9f10f3f0.svg";